import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MobileFolioService } from '@rocksoft/inroom-sdk';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import {
  MobileFolioActionTypes,
  MobileFolioApiMobileFoliosLoaded,
  MobileFolioApiMobileFoliosLoadedError,
  MobileFolioApiMobileFolioUpdated,
  MobileFolioApiMobileFolioUpdatedError,
  MobileFolioResolverMobileFoliosRequested,
  MobileFoliosActionUnion,
  MobileFolioViewSaveOrder,
} from './mobilefolio.actions';

@Injectable()
export class MobileFolioEffects {
  private readonly actions$ = inject<Actions<MobileFoliosActionUnion>>(Actions);
  private readonly mobileFolioService = inject(MobileFolioService);

  resolveMobileFolioEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MobileFolioActionTypes.MOBILE_FOLIO_RESOLVER_MOBILE_FOLIOS_REQUESTED),
      mergeMap((action: MobileFolioResolverMobileFoliosRequested) =>
        this.mobileFolioService.lookupByReservationId({ reservationId: +action.payload.reservationId }).pipe(
          map((result) => new MobileFolioApiMobileFoliosLoaded({ mobileFolio: result.Data ?? {} })),
          catchError((error) => of(new MobileFolioApiMobileFoliosLoadedError({ error })))
        )
      )
    );
  });

  saveMobileFolioEffect$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(MobileFolioActionTypes.MOBILE_FOLIO_VIEW_SAVE_ORDER),
      mergeMap((action: MobileFolioViewSaveOrder) =>
        this.mobileFolioService.setfolio({ proformaInvoiceApiModel: action.payload.mobileFolio }).pipe(
          map(() => new MobileFolioApiMobileFolioUpdated({ mobileFolio: action.payload.mobileFolio })),
          catchError((error) =>
            of(
              new MobileFolioApiMobileFolioUpdatedError({
                originalMobileFolio: action.payload.mobileFolio,
                mobileFolio: action.payload.mobileFolio,
                error: error,
              })
            )
          )
        )
      )
    );
  });
}
